import React, { createContext, useState, useContext, ReactNode } from "react";

interface LoaderContextProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const NotificationContext = createContext<any>({});

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [show, setShow] = useState<boolean>(false);

  return (
    <NotificationContext.Provider value={{ show, setShow }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = (): LoaderContextProps => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error("useLoader must be used within a NotificationProvider");
  }
  return context;
};

export default NotificationContext;
